import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import { getPropertyComplianceDates } from 'reducers/complianceDatesPortfolioReducer';

import Spinner from 'components/Spinner';
import NothingFoundCardContent from 'components/NothingFoundCardContent';
import ComplianceDatesCollapse from 'components/complianceCalendar/ComplianceDatesCollapse';

import { groupComplianceDatesByDepartment } from 'utils/complianceDatesUtils';

// import './ComplianceDatesChecklist.css';

function ComplianceDatesChecklist(props) {
	const dispatch = useDispatch();
	const { propertyId, hideSpinner } = props;
	const {
		isLoading,
		complianceData,
		address,
	} = useSelector(state => ({
		isLoading: state.complianceDatesPortfolio.isLoading || state.property.isLoading,
		complianceData: groupComplianceDatesByDepartment(state.complianceDatesPortfolio.data),
		address: state.property.propertyData?.address,
	}));

	/* eslint-disable react-hooks/exhaustive-deps */
	useEffect(() => {
		if (propertyId) {
			dispatch(getPropertyComplianceDates(propertyId));
		}
	}, [propertyId, dispatch]);

	let nothingFoundText = null;


	return (
		<div>
			{(isLoading && !hideSpinner) && <Spinner />}
			{props.showCalendarLink ? <div className="mb-2">
				<Link to={`/property/${address}/calendar`}>View in Calendar</Link>
			</div> : null}
			{!isLoading && !Object.keys(complianceData).length && <NothingFoundCardContent text={nothingFoundText} />}
			{Object.keys(complianceData).map((section) => (
				<ComplianceDatesCollapse key={section} sectionName={section} data={complianceData[section]} address={address} />
			))}
		</div>
	);
}

export default ComplianceDatesChecklist;
